// extracted by mini-css-extract-plugin
export var container = "styles-module__container___woseL";
export var riverClass = "styles-module__riverClass___eyaw4";
export var title = "styles-module__title___vozAU";
export var next = "styles-module__next___luPZ9";
export var previous = "styles-module__previous___rVyG2";